import { useState } from 'react';
import './App.css';
import Button from './Button';
import Header from './Header';
import Intro from './Intro';
import ProgressBar from './ProgressBar';
import Space from './Space';
import Quiz from './Quiz';
import Results from './Results';

function App() {
    const [progress, setProgress] = useState(0);
    const [pageState, setPageState] = useState('intro');
    const [answers, setAnswers] = useState([]);
    // const [answers, setAnswers] = useState([0, 1, 2, 0, 2, 2, 0, 2, 1, 1]);

    const appendAnswer = (answer) => {
        const tempAnswers = [...answers];
        tempAnswers.push(answer);
        setAnswers(tempAnswers);
    };

    return (
        <div className="app">
            <div className="inner-app">
                <Header />
                <Space s={8} />
                <ProgressBar progress={progress} />
                {(['intro', ''].includes(pageState) || !pageState) && <Intro setPageState={setPageState} />}
                {pageState === 'quiz' && (
                    <Quiz setProgress={setProgress} setPageState={setPageState} appendAnswer={appendAnswer} />
                )}

                {pageState === 'results' && (
                    <Results setProgress={setProgress} setPageState={setPageState} answers={answers} />
                )}
            </div>
        </div>
    );
}

export default App;
